const amplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: '',
            userPoolClientId: '',
            signUpVerificationMethod: 'code' as const,
        },
    },
};

export default amplifyConfig;
